var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRefleshAltLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98749 3.04883C13.5116 3.04883 16.3937 6.00216 16.3937 9.67685C16.3937 13.3515 13.5116 16.3049 9.98749 16.3049C6.78823 16.3049 4.11929 13.8725 3.65317 10.6738C3.61584 10.4176 3.3779 10.2402 3.12172 10.2775C2.86555 10.3148 2.68814 10.5528 2.72547 10.809C3.25447 14.4392 6.29382 17.2424 9.98749 17.2424C14.0572 17.2424 17.3312 13.841 17.3312 9.67685C17.3312 5.51267 14.0572 2.11133 9.98749 2.11133C6.96677 2.11133 4.38185 3.98814 3.25287 6.65543C3.15197 6.89384 3.26343 7.16891 3.50184 7.26982C3.74024 7.37073 4.01531 7.25926 4.11622 7.02085C5.10903 4.67526 7.36983 3.04883 9.98749 3.04883Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42499 2.82099C3.16611 2.82099 2.95624 3.03086 2.95624 3.28974V6.46313C2.95624 6.92912 3.334 7.30688 3.79999 7.30688H6.86249C7.12137 7.30688 7.33124 7.09701 7.33124 6.83813C7.33124 6.57924 7.12137 6.36938 6.86249 6.36938H3.89374V3.28974C3.89374 3.03086 3.68387 2.82099 3.42499 2.82099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefleshAltLined);
export default __webpack_public_path__ + "static/media/ic_reflesh_alt_lined.c44fab67f71e6d0818452d3b758ce7f0.svg";
export { ForwardRef as ReactComponent };